type PageBreakpointName = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export const pageBreakpoints: Record<PageBreakpointName, string> = {
  xs: '0',
  sm: '567px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
}
